import workspaceQuery from 'graphql/queries/product/CustomerPartNumberWorkspaceQuery.graphql';
import fragment from 'graphql/fragments/product/CustomerPartNumberFragment.graphql';

const CustomerPartNumber = {
  type: 'CustomerPartNumber',
  title: 'Customer Part Numbers',
  workspaceUrl: '/Products/CustomerPartNumber/Workspace/',
  workspace: workspaceQuery,
  fragment,
  screenReference: 'CUSTOMER_PART_NUMBERS',
};

export default CustomerPartNumber;
